import clsx from "clsx";
import type { ComponentProps, CSSProperties } from "react";

import type { TableBlockType } from "@features/article-content/model";

import { Body, Heading } from "@shared/ui/typography";

import s from "./sizes-popup.module.scss";

export type CompProps = ComponentProps<"div"> & {
  className?: string;
  popupData: {
    tableSize: TableBlockType;
    popup: {
      title: string;
      description: string;
    };
  };
};

export const SizesPopup = (props: CompProps) => {
  const { className, popupData } = props;

  const columnCount = popupData.tableSize.columnTitle?.length || 0;

  return (
    <div className={clsx(s.root, className)}>
      <div className={s.top}>
        <Heading level={5}>
          {popupData.popup.title || "Как определить размер?"}
        </Heading>
        {popupData.popup.description && (
          <Body size="caption-small" weight="semiBold">
            {popupData.popup.description}
          </Body>
        )}
      </div>

      <Heading level={6} className={s.title}>
        {popupData.tableSize.title}
      </Heading>

      <table
        className={s.container}
        style={
          {
            "--table-column-count": columnCount,
          } as CSSProperties
        }
      >
        <thead>
          <tr className={s.row}>
            {popupData.tableSize.columnTitle?.map(({ title, id }) => (
              <Body tag="td" key={`${title}_${id}`} weight="semiBold">
                {title}
              </Body>
            ))}
          </tr>
        </thead>
        <tbody className={s.body}>
          {popupData.tableSize.tabletRows?.length > 0 &&
            popupData.tableSize.tabletRows.map((row, idx) => (
              <tr key={`row_${idx + 1}`} className={clsx(s.row)}>
                {row.rowItem.map((item, index) => (
                  <Body
                    tag="td"
                    key={`row_item-${item}-${index + 1}`}
                    data-label={`${popupData.tableSize.columnTitle[index]?.title || ""}`}
                    // weight={index === 0 ? "semiBold" : "regular"}
                    className={s.value}
                  >
                    {index === 0 && (
                      <span className={s.label}>
                        {popupData.tableSize.columnTitle[index].title}
                      </span>
                    )}
                    <span>{item.text}</span>
                  </Body>
                ))}
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

SizesPopup.displayName = "SizesPopup";
